/**
 * Created by sswaminathan on 6/2/22
 * File: ModifySubscriptionModal
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

import { toNumber } from 'lodash'
// import statement lib, local then scss or css
/**
 *   TODO: Brief what is this component/class do
 */
import { useCallback, useContext, useEffect, useState } from 'react'
import { Form, FormLayout, SubmitButton } from '@panwds/react-form-legacy'
import { LoadingPage, Button, Modal, ModalBody, ModalFooter, ModalHeader } from '@panwds/react-ui'
import { SubmitSubscriptionModification } from '../../../common/actions/GlobalActions'
import ZIndex from '../../../common/components/zIndex/ZIndex'
import { APP_ID_PRISMA_ACCESS_EDITION, APP_ID_SDWAN } from '../../../common/constants/GlobalConstants'
import AppContext from '../../../common/context/AppContext'
import { setShowActionStatus } from '../../../common/reducers/actions/ViewReducer.actions'
import {
  CANCEL_BUTTON, EVAL_TO_PROD_SUBSCRIPTION_SUCCESS,
  MODIFY_SUBSCRIPTION_BUTTON_TEXT,
  MODIFY_SUBSCRIPTION_SERVICE_ERROR, MODIFY_SUBSCRIPTION_SUCCESS,
  MODIFY_SUBSCRIPTION_VALID_DATA,
  NOTE_SECTION
} from '../constants/SubscriptionConstant'
import ModifySubscription from '../modifySubscription/ModifySubscription'

const ModifySubscriptionModal = (props) => {
  const { closeModal, isOpen, title, row, licenseDetails, globalTsgId, dispatch } = props
  const [appInformation, setAppInformation] = useState({})
  const [isFormLoading, setFormLoading] = useState(false)
  const [disabled, setDisabled] = useState(true)
  const [showErrorMsg, setShowErrorMsg] = useState({ showError: false, errorMsg: '' })
  const { getAppName } = useContext(AppContext)

  useEffect(() => {
    if (row?.values) {
      const filterByLicenseID = licenseDetails.find((each) => {
        return each.licenses?.[0]?.license_id === row?.values.license_id
      })
      if (filterByLicenseID?.licenses?.[0]) {
        const appDetails = {}
        const licenseInfo = filterByLicenseID.licenses[0]
        if (licenseInfo?.app_id !== APP_ID_SDWAN) {
          licenseInfo.entitlements.forEach(({ app_id, product_type, license_display_name }) => {
            if (product_type !== 'PA-ADD' && !appDetails[app_id]) {
              let tenant_id = ''
              if (app_id === APP_ID_PRISMA_ACCESS_EDITION || app_id === APP_ID_SDWAN) {
                tenant_id = licenseInfo.tenant_id
              }
              else {
                licenseInfo.related_products?.forEach((each) => {
                  if (each.app_id === license_display_name) {
                    tenant_id = each.tenant_id
                  }
                })
              }
              appDetails[app_id] = {
                serial_number: licenseInfo.serial_number ?? '',
                csp_tenant_id: tenant_id,
                support_account_id: licenseInfo.support_account_id,
                app_id,
                license_display_name: app_id !== APP_ID_PRISMA_ACCESS_EDITION ? license_display_name : licenseInfo.license_display_name
              }
            }
          })
        }
        else {
          appDetails[licenseInfo?.app_id] = {
            csp_tenant_id: licenseInfo.tenant_id,
            support_account_id: licenseInfo.support_account_id,
            app_id: licenseInfo?.app_id,
            license_display_name: getAppName(licenseInfo?.app_id) }
        }
        setAppInformation(appDetails)
      }
    }
  }, [getAppName, licenseDetails, row?.values])


  const errorHandler = useCallback((message) => {
    setFormLoading(false)
    setShowErrorMsg({ showError: true, errorMsg: message ?? MODIFY_SUBSCRIPTION_VALID_DATA })
    setTimeout(() => {
      setShowErrorMsg({ showError: false, errorMsg: '' })
    }, 5000)
  }, [])

  const onSubmit = useCallback(async (values) => {
    setFormLoading(true)
    const request = {
      support_account_id: '',
      subscription_info: []
    }
    const keys = Object.keys(values)
    keys.forEach((each) => {
      if (values[each] && values[each].length > 0 && values[each] !== NOTE_SECTION) {
        const info = {
          'csp_tenant_id': appInformation[each]?.csp_tenant_id,
          'app_id': appInformation[each]?.app_id,
          'user_request': values[each]
        }
        request.claimed_tsg = row?.values.tsg_id
        request.support_account_id = toNumber(appInformation[each]?.support_account_id)
        request.subscription_info.push(info)
      }
    })
    if (request.subscription_info.length > 0) {
      await SubmitSubscriptionModification(globalTsgId, request).then((data) => {
        setFormLoading(false)
        dispatch(setShowActionStatus(row.original.isEval ? EVAL_TO_PROD_SUBSCRIPTION_SUCCESS : MODIFY_SUBSCRIPTION_SUCCESS))
        setTimeout(() => {
          dispatch(setShowActionStatus('NONE'))
        }, 5000)
        closeModal()
      }).catch((err) => {
        errorHandler(err.message ?? MODIFY_SUBSCRIPTION_SERVICE_ERROR)
      })
    }
    else {
      setDisabled(true)
      errorHandler(MODIFY_SUBSCRIPTION_VALID_DATA)

    }
  }, [appInformation, closeModal, dispatch, errorHandler, globalTsgId, row.original.isEval, row?.values.tsg_id])

  return <ZIndex>
    {isFormLoading && <LoadingPage/>}
    <Modal style={{ top: '12%', height: '373px', width: '390px' }}
      onClose={closeModal}
      isOpen={isOpen}
      confirmClose={false}
    >
      <Form style={{ width: '50%' }} mode='onBlur' onSubmit={onSubmit} formProps={{ autoComplete: 'off', position: 'relative' }} >
        <FormLayout>
          <div className='tw-flex tw-flex-col'>
            <ModalHeader title={title} />
            <ModalBody style={{ padding: '0px' }} >
              <ModifySubscription {...{ appInformation, isFormLoading, setDisabled, showErrorMsg, ...props }} />
            </ModalBody>
            <ModalFooter style={{ bottom: '0px', position: 'absolute', width: '100%' }}>
              <Button onClick={closeModal} >
                {CANCEL_BUTTON}
              </Button>
              <SubmitButton
                appearance={'primary'}
                disabled={disabled}
                type={'submit'}>
                {MODIFY_SUBSCRIPTION_BUTTON_TEXT}
              </SubmitButton>
            </ModalFooter>
          </div>
        </FormLayout>
      </Form>
    </Modal>
  </ZIndex>
}
export default ModifySubscriptionModal
